Updates a candidate process history item.
